import { captureException } from "@storytell/analytics";
import commonEmails from "email-providers/all.json";
import { isGuestEmail } from "./auth.helpers";

const eduDomainRegex = /\.(edu|sch|ac|academy|college|education|institute|school|university)/;

// Determines the type of email based on the domain
// Returns "business", "personal", "education", or "government"
export const getEmailTypeFromDomain = (email: string): "business" | "personal" | "education" | "government" => {
  if (isGuestEmail(email)) return "personal";
  try {
    const domain = email.split("@").pop();
    if (!domain) return "business";
    if (eduDomainRegex.test(domain)) return "education";
    if (domain.includes(".gov")) return "government";
    if (!commonEmails.some((e) => e.endsWith(domain))) return "business";
  } catch (error) {
    captureException(error);
    console.error(error);
  }
  return "personal";
};
